export const languages = [
    {
        id:1,
        language:'Hindi',
        languageLogo: 'अ'
    },
    {
        id:2,
        language:'Telugu',
        languageLogo: 'తె'
    },
    {
        id:3,
        language:'English',
        languageLogo: 'A'
    },
    {
        id:4,
        language:'Tamil',
        languageLogo: 'அ'
    },
    {
        id:5,
        language:'Marathi',
        languageLogo: 'अ'
    },
    {
        id:6,
        language:'Kannada',
        languageLogo: 'ಷ'
    },
    {
        id:7,
        language: 'Bengali',
        languageLogo:'অ'
    },
    {
        id:8,
        language:'Gujarati',
        languageLogo:'અ',
    }
]